import React, { Component } from 'react';
import {
  Box,
  Button,
  Drawer,
  Stack,
  TextField,
  Typography,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { withTranslation } from 'react-i18next';
import Autocomplete from '@mui/material/Autocomplete';
import CloseIcon from '@mui/icons-material/Close';
import '../reports.css';
import CommonDatePicker from '../../../../Components/Common Components/CommonDatePicker';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { CommonGridToolBarWithFilterText } from "../../../../Components/Common Components/CommonComponents";
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { formatDate, ContentInTooltip } from "../../../../Components/CommonFunctions/CommonFunctions";
import { DateTime } from 'luxon';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import { localGetItem } from '../../../../Utility/Services/CacheProviderService';

class AuditLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      pageSize: 10,

      fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      dateIndex: 1,
      moduleTypes: [],
      selectedModuleType: null,
      actionTypes: [],
      users: [],
      selectedUser: null,
      UserDetails: [],
      billType: '',

      auditLogs: [],
      filteredFromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      filteredToDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),

      isLoader: false,
      isErrorMsg: false,
      isErrorMsgText: '',
      filterOpen: false
    };
  }

  componentDidMount() {
    this.getAuditLogs();
    this.GetUserDetails();
  }

  getAuditLogs = () => {
    try {
      this.setState({ isLoader: true });

      let queryParams = `?from_date=${this.state.fromDate}&to_date=${this.state.toDate}&page=${this.state.page + 1}&limit=${this.state.pageSize}`;

      if (this.state.selectedModuleType) {
        queryParams += `&bill_type=${encodeURIComponent(this.state.selectedModuleType)}`;
      }
      if (this.state.selectedUser) {
        queryParams += `&user_id=${this.state.selectedUser}`;
      }

      RestAPIService.getAll(Serviceurls.AUDIT_LOG + queryParams)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              auditLogs: response.data.data || [],
              filteredFromDate: this.state.fromDate,
              filteredToDate: this.state.toDate,
              isLoader: false,
              filterOpen: false
            });
          } else {
            this.setState({ isLoader: false });
            this.showErrorMessage(response.data.message || 'Failed to fetch audit logs');
          }
        })
        .catch((error) => {
          this.setState({ isLoader: false });
          this.showErrorMessage(error);
        });
    } catch (error) {
      this.setState({ isLoader: false });
      this.showErrorMessage(error);
    }
  };

  GetUserDetails = () => {
    try {
      RestAPIService.getAll(Serviceurls.DAY_END_USER_DETAIL_GET + `?show_all=true`)
        .then((response) => {
          if (response.data.status === 'success') {
            const UserList = response.data.data
            this.setState({
              UserList: UserList
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.status === 'fail') {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }

        })
    } catch (error) {
      this.errorMessage(error)
    }
  }

  showErrorMessage = (error) => {
    const message = error?.response?.data?.message || error?.message || 'An error occurred';
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    });
  };

  handleDateChange = (from, to, index) => {
    this.setState({
      fromDate: from,
      toDate: to,
      dateIndex: index
    });
  };

  handleClearFilters = () => {
    this.setState({
      fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      dateIndex: 1,
      selectedModuleType: null,
      selectedUser: null,
      filterOpen: false,
      UserDetails: [],
    }, () => {
      this.getAuditLogs();
    });
  };

  handleApplyFilters = () => {
    this.getAuditLogs();
    this.setState({ filterOpen: false });
  };

  renderFilterScreen = () => {
    const { t } = this.props;
    const billTypeOptions = [
      { value: 'bill', label: 'Bill Date Modification' },
      { value: 'receipt', label: 'Receipt Date Modification' },
      { value: 'Doctor Registration Number', label: 'Doctor Registration Number Modification' }
    ];

    return (
      <Box component={"div"} className='eMed_rts_filter_container' sx={{ width: '22vw' }}>
        <Box component={"div"} className='eMed_filter_Top'>
          <Typography variant='h6' fontWeight={600}>{t("Filter")}</Typography>
          <IconButton
            onClick={() => this.setState({ filterOpen: false })}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box className='eMed_rts_middle' sx={{ p: 2 }}>
          {/* Date Picker */}
          <Box className='eMed_date_filter' sx={{ mb: 3 }}>
            <CommonDatePicker
              FromDate={this.state.fromDate}
              ToDate={this.state.toDate}
              DateIndex={this.state.dateIndex}
              SelectedDates={this.handleDateChange}
              HideAllMenu={true}
            />
          </Box>

          <Box className='eMed_rts_dropdown'>
            {localGetItem("isNewBilling") === 'true' ? <FormControl fullWidth size="small">
              <InputLabel>{t('Audit Type')}</InputLabel>
              <Select
                value={this.state.selectedModuleType}
                label={t('Audit Type')}
                onChange={(e) => this.setState({ selectedModuleType: e.target.value })}
              >
                {billTypeOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> : null}
          </Box>
          <Box className='eMed_rts_dropdown'>
            <Autocomplete
              multiple
              limitTags={1}
              size='small'
              options={this.state?.UserList || []}
              getOptionLabel={(options) => options?.user_name}
              onChange={(e, value) => {
                const userIds = value.map(user => user.id);
                this.setState({
                  UserDetails: value,
                  selectedUser: userIds.length > 0 ? userIds.join(',') : null
                });
              }}
              closeOnSelect
              disableCloseOnSelect={false}
              disablePortal
              autoComplete='off'
              value={this.state.UserDetails || []}
              id="combo-box-demo"
              renderInput={(params) => <TextField fullWidth {...params} label={t('Modified By')} size='small' />}
            />
          </Box>
        </Box>

        {/* Action Buttons */}
        <Stack
          spacing={2}
          direction="row"
          alignItems="center"
          justifyContent="center"
          sx={{ p: 2, borderTop: '1px solid #e0e0e0' }}
        >
          <Button
            variant='outlined'
            size="small"
            onClick={this.handleClearFilters}
            sx={{ textTransform: 'capitalize' }}
          >
            {t("Clear")}
          </Button>
          <Button
            variant='contained'
            size="small"
            onClick={this.getAuditLogs}
            sx={{ textTransform: 'capitalize' }}
          >
            {t("Search")}
          </Button>
        </Stack>
      </Box>
    );
  };

  gridToolBar = () => {
    const textArray = [
      { label: "From Date", value: formatDate(this.state.filteredFromDate) },
      { label: "To Date", value: formatDate(this.state.filteredToDate) },
    ];

    return (
      <Box >
        <CommonGridToolBarWithFilterText FilterTextArray={textArray} />
      </Box>
    );
  };

  render() {
    const { t } = this.props;

    const rowsWithSerial = this.state.auditLogs.map((item, index) => ({
      ...item,
      id: item.id || `audit-${index}`,
      sno: index + 1
    }));

    const columns = [
      { field: 'sno', headerName: 'S.No', flex: 0.05 },
      {
        field: "bill_type_display",
        headerName: t("Audit Type"),
        flex: 0.2,
        renderCell: (params) => (
          <Box component={'div'}>{ContentInTooltip(params?.row?.bill_type_display || "-", 30)}</Box>
        )
      },
      {
        field: "previous_data",
        headerName: t("Previous Data"),
        flex: 0.2,
        renderCell: (params) => (
          <Box component={'div'}>{ContentInTooltip(params?.row?.previous_data || "-", 30)}</Box>
        )
      },
      {
        field: "modified_data",
        headerName: t("Modified Data"),
        flex: 0.2,
        renderCell: (params) => (
          <Box component={'div'}>{ContentInTooltip(params?.row?.modified_data || "-", 30)}</Box>
        )
      },
      {
        field: "user_name",
        headerName: t("Modified By"),
        flex: 0.2,
        renderCell: (params) => (
          <Box component={'div'}>{ContentInTooltip(params?.row?.user_name || "-", 30)}</Box>
        )
      },
      {
        field: "created_date_display",
        headerName: t("Modified Details"),
        flex: 0.15,
        renderCell: (params) => (
          <Box component={'div'}>{ContentInTooltip(params?.row?.created_date_display || "-", 30)}</Box>
        )
      },
    ];

    return (
      <Box component={'div'} className='eMed_rts_container'>
        <Box component={"div"} className='eMed_Top_Container'>
          <Box component={"div"} className='eMed_Action_Container' sx={{ width: '100%' }}>
            <Box component={"div"} className='eMed_Filter_Icon_div' display={'flex'} padding={'0.5vw'}>
              <Button className='eMed_usrconf_btn' onClick={() => { this.setState({ filterOpen: true }) }}>
                <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
              </Button>
            </Box>
          </Box>
        </Box>

        <Box component={'div'} className='eMed_rts_table'
          sx={{
            minHeight: '400px',
            width: '100%',
            position: 'relative'
          }}
        >
          <DataGrid
            rows={rowsWithSerial}
            columns={columns}
            getRowId={(row) => row.id}
            page={this.state.page}
            pageSize={this.state.pageSize}
            rowsPerPageOptions={[10, 20, 50]}
            pagination
            onPageChange={(newPage) => this.setState({ page: newPage })}
            onPageSizeChange={(newPageSize) =>
              this.setState({ pageSize: newPageSize }, this.getAuditLogs)
            }
            localeText={{
              toolbarColumns: "",
              toolbarDensity: "",
              toolbarExport: "",
              toolbarFilters: "",
              toolbarExportPrint: ""
            }}
            components={{
              Toolbar: this.gridToolBar,
              NoRowsOverlay: () => (
                <Stack className='eMed_conf_nodata'
                  sx={{
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#666'
                  }}
                >
                  {t("NoRecordsFound")}
                </Stack>
              )
            }}
            loading={this.state.isLoader}
            disableSelectionOnClick
            autoHeight={false}
          />
        </Box>

        {/* Filter Drawer */}
        <Drawer
          anchor={'right'}
          open={this.state.filterOpen}
          onClose={() => this.setState({ filterOpen: false })}
          PaperProps={{
            sx: { width: '24vw' }
          }}
        >
          {this.renderFilterScreen()}
        </Drawer>

        {/* Error Toast */}
        {this.state.isErrorMsg && (
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={() => this.setState({
              isErrorMsg: false,
              isErrorMsgText: ''
            })}
          />
        )}
      </Box>
    );
  }
}

export default withTranslation()(AuditLog);